"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesSchema = exports.createDataSchema = exports.createWeakDataRef = exports.createDataRef = void 0;
// Side effect for enriching yup
require("./yupEnrcihment");
var yup_1 = require("yup");
var Core_schema_1 = require("./Core.schema");
exports.createDataRef = function (schemas) { return yup_1.string().meta({ schemas: schemas }); };
exports.createWeakDataRef = function (schemaType) {
    return yup_1.string().meta({ schemaType: schemaType, weakRef: true });
};
var createSchema = function (type, schema) {
    var baseSchema = yup_1.object({
        id: yup_1.string().required(),
        type: yup_1.mixed()
            .oneOf([type])
            .default(type),
    });
    return schema.concat(baseSchema);
};
exports.createDataSchema = createSchema;
exports.createPropertiesSchema = function (type, schema) {
    return createSchema(type, schema).concat(Core_schema_1.defaultProperties);
};
//# sourceMappingURL=schemaUtils.js.map